var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrcode-container"},[_c('img',{attrs:{"src":require("../assets/images/qrcode.jpg")}}),_c('p',{domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }